/* eslint-disable jsx-a11y/alt-text */
import React from 'react';

const iconsOptions = [
  {
    label: (
      <>
        <img
          style={{ width: '40px' }}
          src={`${process.env.PUBLIC_URL}/assets/icons/ic_calculadora.svg`}
        />
        <p style={{ marginLeft: '1rem' }}>Calculadora</p>
      </>
    ),
    value: `${process.env.PUBLIC_URL}/assets/icons/ic_calculadora.svg`,
  },
  {
    label: (
      <>
        <img
          style={{ width: '40px' }}
          src={`${process.env.PUBLIC_URL}/assets/icons/ic_relatory.svg`}
        />
        <p style={{ marginLeft: '1rem' }}>Relatório</p>
      </>
    ),
    value: `${process.env.PUBLIC_URL}/assets/icons/ic_relatory.svg`,
  },
  {
    label: (
      <>
        <img
          style={{ width: '40px' }}
          src={`${process.env.PUBLIC_URL}/assets/icons/ic_cad_instruction.svg`}
        />
        <p style={{ marginLeft: '1rem' }}>Instrução</p>
      </>
    ),
    value: `${process.env.PUBLIC_URL}/assets/icons/ic_cad_instruction.svg`,
  },
  {
    label: (
      <>
        <img
          style={{ width: '40px' }}
          src={`${process.env.PUBLIC_URL}/assets/icons/ic_files.svg`}
        />
        <p style={{ marginLeft: '1rem' }}>Arquivos</p>
      </>
    ),
    value: `${process.env.PUBLIC_URL}/assets/icons/ic_files.svg`,
  },
  {
    label: (
      <>
        <img
          style={{ width: '40px' }}
          src={`${process.env.PUBLIC_URL}/assets/icons/ic_perfil.svg`}
        />
        <p style={{ marginLeft: '1rem' }}>Perfil</p>
      </>
    ),
    value: `${process.env.PUBLIC_URL}/assets/icons/ic_perfil.svg`,
  },
  {
    label: (
      <>
        <img
          style={{ width: '40px' }}
          src={`${process.env.PUBLIC_URL}/assets/icons/ic_cartao_credito.svg`}
        />
        <p style={{ marginLeft: '1rem' }}>Cartão de crédito</p>
      </>
    ),
    value: `${process.env.PUBLIC_URL}/assets/icons/ic_cartao_credito.svg`,
  },
  {
    label: (
      <>
        <img
          style={{ width: '40px' }}
          src={`${process.env.PUBLIC_URL}/assets/icons/ic_cartoes.svg`}
        />
        <p style={{ marginLeft: '1rem' }}>Cartões</p>
      </>
    ),
    value: `${process.env.PUBLIC_URL}/assets/icons/ic_cartoes.svg`,
  },
  {
    label: (
      <>
        <img
          style={{ width: '40px' }}
          src={`${process.env.PUBLIC_URL}/assets/icons/ic_consorcio.svg`}
        />
        <p style={{ marginLeft: '1rem' }}>Consórcio</p>
      </>
    ),
    value: `${process.env.PUBLIC_URL}/assets/icons/ic_consorcio.svg`,
  },
  {
    label: (
      <>
        <img
          style={{ width: '40px' }}
          src={`${process.env.PUBLIC_URL}/assets/icons/ic_conta_corrente.svg`}
        />
        <p style={{ marginLeft: '1rem' }}>Conta Corrente</p>
      </>
    ),
    value: `${process.env.PUBLIC_URL}/assets/icons/ic_conta_corrente.svg`,
  },
  {
    label: (
      <>
        <img
          style={{ width: '40px' }}
          src={`${process.env.PUBLIC_URL}/assets/icons/ic_credito.svg`}
        />
        <p style={{ marginLeft: '1rem' }}>Crédito</p>
      </>
    ),
    value: `${process.env.PUBLIC_URL}/assets/icons/ic_credito.svg`,
  },
  {
    label: (
      <>
        <img
          style={{ width: '40px' }}
          src={`${process.env.PUBLIC_URL}/assets/icons/ic_dashboard.svg`}
        />
        <p style={{ marginLeft: '1rem' }}>Dashboard</p>
      </>
    ),
    value: `${process.env.PUBLIC_URL}/assets/icons/ic_dashboard.svg`,
  },
  {
    label: (
      <>
        <img
          style={{ width: '40px' }}
          src={`${process.env.PUBLIC_URL}/assets/icons/ic_dinheiro.svg`}
        />
        <p style={{ marginLeft: '1rem' }}>Dinheiro</p>
      </>
    ),
    value: `${process.env.PUBLIC_URL}/assets/icons/ic_dinheiro.svg`,
  },
  {
    label: (
      <>
        <img
          style={{ width: '40px' }}
          src={`${process.env.PUBLIC_URL}/assets/icons/ic_investimentos.svg`}
        />
        <p style={{ marginLeft: '1rem' }}>Investimentos</p>
      </>
    ),
    value: `${process.env.PUBLIC_URL}/assets/icons/ic_investimentos.svg`,
  },
  {
    label: (
      <>
        <img
          style={{ width: '40px' }}
          src={`${process.env.PUBLIC_URL}/assets/icons/ic_manual.svg`}
        />
        <p style={{ marginLeft: '1rem' }}>Manual</p>
      </>
    ),
    value: `${process.env.PUBLIC_URL}/assets/icons/ic_manual.svg`,
  },
  {
    label: (
      <>
        <img
          style={{ width: '40px' }}
          src={`${process.env.PUBLIC_URL}/assets/icons/ic_mensagem_de_critica.svg`}
        />
        <p style={{ marginLeft: '1rem' }}>Mensagem Crítica</p>
      </>
    ),
    value: `${process.env.PUBLIC_URL}/assets/icons/ic_mensagem_de_critica.svg`,
  },
  {
    label: (
      <>
        <img
          style={{ width: '40px' }}
          src={`${process.env.PUBLIC_URL}/assets/icons/ic_pagamentos.svg`}
        />
        <p style={{ marginLeft: '1rem' }}>Pagamentos</p>
      </>
    ),
    value: `${process.env.PUBLIC_URL}/assets/icons/ic_pagamentos.svg`,
  },
  {
    label: (
      <>
        <img
          style={{ width: '40px' }}
          src={`${process.env.PUBLIC_URL}/assets/icons/ic_previdencia.svg`}
        />
        <p style={{ marginLeft: '1rem' }}>Previdência</p>
      </>
    ),
    value: `${process.env.PUBLIC_URL}/assets/icons/ic_previdencia.svg`,
  },
  {
    label: (
      <>
        <img
          style={{ width: '40px' }}
          src={`${process.env.PUBLIC_URL}/assets/icons/ic_question.svg`}
        />
        <p style={{ marginLeft: '1rem' }}>Pergunta</p>
      </>
    ),
    value: `${process.env.PUBLIC_URL}/assets/icons/ic_question.svg`,
  },
  {
    label: (
      <>
        <img
          style={{ width: '40px' }}
          src={`${process.env.PUBLIC_URL}/assets/icons/ic_seguranca.svg`}
        />
        <p style={{ marginLeft: '1rem' }}>Segurança</p>
      </>
    ),
    value: `${process.env.PUBLIC_URL}/assets/icons/ic_seguranca.svg`,
  },
  {
    label: (
      <>
        <img
          style={{ width: '40px' }}
          src={`${process.env.PUBLIC_URL}/assets/icons/ic_seguros.svg`}
        />
        <p style={{ marginLeft: '1rem' }}>Seguros</p>
      </>
    ),
    value: `${process.env.PUBLIC_URL}/assets/icons/ic_seguros.svg`,
  },
  {
    label: (
      <>
        <img
          style={{ width: '40px' }}
          src={`${process.env.PUBLIC_URL}/assets/icons/ic_servicos.svg`}
        />
        <p style={{ marginLeft: '1rem' }}>Serviços</p>
      </>
    ),
    value: `${process.env.PUBLIC_URL}/assets/icons/ic_servicos.svg`,
  },
  {
    label: (
      <>
        <img
          style={{ width: '40px' }}
          src={`${process.env.PUBLIC_URL}/assets/icons/ic_telefone.svg`}
        />
        <p style={{ marginLeft: '1rem' }}>Telefone</p>
      </>
    ),
    value: `${process.env.PUBLIC_URL}/assets/icons/ic_telefone.svg`,
  },
  {
    label: (
      <>
        <img
          style={{ width: '40px' }}
          src={`${process.env.PUBLIC_URL}/assets/icons/ic_pin.svg`}
        />
        <p style={{ marginLeft: '1rem' }}>Pin</p>
      </>
    ),
    value: `${process.env.PUBLIC_URL}/assets/icons/ic_pin.svg`,
  },
];

export default iconsOptions;
